module.exports = __webpack_public_path__ + "img/雪山2_1.0efbdba6.jpg";